export default __webpack_public_path__ + "media/components/AdEdit/images/facebook-audience-network-close-177a14a9cc66727cee72fdb920f9fdcf.png";